export const CONTENT = {
  it: {
    servicePages: {
      interior: {
        overline: "Architettura e Design d'Interni",
        title: "La visione precede il cantiere.",
        intro: "Lavoriamo in collaborazione con architetti di riferimento, dal sopralluogo allo studio degli spazi, fino a ogni dettaglio tecnico e decorativo. Compila il form guidato: ci serve per capire il tuo spazio e preparare un preventivo vero.",
        phases: [
          { num: "01", items: ["Sopralluoghi, rilievi e analisi", "Studio di fattibilità tecnico ed economico", "Progettazione", "Moodboard", "Render", "Landscape"] },
          { num: "02", items: ["Titoli edilizi", "Occupazione suolo pubblico", "Prevenzione incendi"] },
          { num: "03", items: ["Esecutivi impianti elettrici, meccanici, ecc.", "Coordinamento della sicurezza (CSP-CSE)", "Direzione lavori"] },
          { num: "04", items: ["Accatastamento", "Agibilità"] },
        ],
        form: {
          title: "Preventivo guidato.",
          name: "Nome e cognome",
          phoneOptional: "Telefono (facoltativo)",
          desc: "Raccontaci lo spazio: ti richiamiamo con un preventivo dettagliato.",
          step1: { label: "Che tipo di spazio è?", options: ["Appartamento", "Casa indipendente", "Ufficio", "Negozio / showroom", "Altro"] },
          step2: { area: "Superficie in m² (indicativa)", rooms: "Ambienti principali (es. 2 camere, soggiorno, 1 bagno)" },
          step3: { finish: "Livello di finiture", finishOptions: ["Essenziale", "Media", "Alta"], condition: "Stato attuale dello spazio", conditionOptions: ["Vuoto", "Abitato / arredato", "Da ristrutturare"] },
          step4: { services: "Di cosa hai bisogno?", servicesOptions: ["Solo il progetto", "Progetto + forniture", "Chiavi in mano"], notes: "Note (facoltative)", notesPlaceholder: "Tempi, vincoli, particolarità…" },
          back: "Indietro", next: "Avanti", send: "Invia la richiesta",
          success: "Richiesta ricevuta. Ti ricontattiamo con il preventivo entro un giorno lavorativo.",
        },
      },
      contracting: {
        overline: "Realizzazioni",
        works: ["Cantierizzazione", "Demolizione e realizzazione", "Interventi su murature portanti", "Impianti meccanici", "Impianti elettrici", "Impianti speciali", "Infissi", "Sistemazione esterni", "Rivestimenti e decorazioni", "Realizzazione del verde"],
        title: "Regia unica, cantiere senza pensieri.",
        intro: "Coordiniamo ogni impresa, artigiano e fornitore, con una regia unica e tempi verificati. E gestiamo per te tutta la parte documentale che sblocca il cantiere — anche come servizio a sé, se cerchi solo questo.",
        docs: {
          title: "I documenti che sbloccano il cantiere.",
          desc: "Ogni intervento ha una via burocratica diversa: noi la prendiamo in carico dall'inizio alla fine.",
          items: [
            { name: "CILA", desc: "La Comunicazione di Inizio Lavoro Asseverata: il via libera per i lavori di importanza minore, firmata da un professionista abilitato. Serve per molte ristrutturazioni senza cambio di destinazione." },
            { name: "SCIA", desc: "Il permesso a finestra per gli interventi più significativi: cambio di destinazione, demolizioni, interventi strutturali. La presentiamo e seguiamo i tempi con il Comune." },
            { name: "Comunicazione Asl", desc: "La notifica di cantiere all'Azienda Sanitaria: obbligatoria prima di aprire il cantiere, la predisponiamo noi con i dati delle imprese." },
            { name: "Agibilità", desc: "Alla fine dei lavori, il certificato di agibilità (o comunicazioni conformi) rende l'immobile edificabile. Lo otteniamo noi, con gli allegati impiantistici firmati." },
            { name: "Autorizzazioni comunali", desc: "Occupazioni suolo pubblico, autorizzazione paesaggistica, esercizio prossimo: verifichiamo quale serve e la richiediamo." },
            { name: "Conformità impianti", desc: "Dichiarazione di conformità di ogni impianto (elettrico, idraulico, gas): la raccogliamo dai professionisti e la consegniamo al cliente." },
          ],
          cta: "Voglio solo questo supporto",
          form: {
            title: "Supporto documentale.",
            desc: "Raccontaci la pratica: ti diciamo subito se e come possiamo prenderla in carico.",
            name: "Nome e cognome", email: "Email", phone: "Telefono (facoltativo)", message: "La pratica o il documento di cui hai bisogno",
            send: "Invia la richiesta", success: "Richiesta ricevuta: ti ricontattiamo entro un giorno lavorativo.",
          },
        },
      },
      showroom: {
        overline: "Showroom e Arredamento",
        title: "Il meglio del design, tutto in un posto.",
        intro: "Nel nostro showroom selezioniamo arredi, illuminazione, materiali e finiture con una consulenza personalizzata: provi i materiali dal vero, tocchi i tessuti e componiamo insieme la casa o lo spazio di lavoro.",
        highlights: [
          { title: "Materiali dal vivo", desc: "Marmi, legni, gress e finiture da provare con le mani, non da catalogo." },
          { title: "Consulenza personalizzata", desc: "Ti accompagniamo nella scelta, coordinando ogni ambiente con il progetto." },
          { title: "Marchi selezionati", desc: "Le migliori aziende per ogni area della casa, senza pensieri di consegna." },
        ],
        cta: "Scopri le aziende partner",
        ctaCustom: "Richiedi un arredo su misura",
      },
      omniway: {
        overline: "Logistica",
        brand: "OMNIWAY",
        by: "di Green Gate S.r.l.",
        title: "La logistica è l'ultima cosa a cui pensare. E la prima a cui pensiamo noi.",
        intro: "OMNIWAY è il servizio logistico interno di Green Gate: ritiriamo direttamente presso i fornitori, trasportiamo con mezzi propri e consegniamo in cantiere o al cliente, al momento giusto.",
        services: [
          { title: "Ritiro presso fornitori", desc: "Prendiamo in carico i materiali direttamente da fabbriche, showroom e magazzini." },
          { title: "Trasporto con mezzi propri", desc: "Il nostro parco veicoli, in ogni dimensione: dal singolo arredo all'intero cantiere." },
          { title: "Consegna in cantiere", desc: "Sgomma, appoggio e posa al piano giusto, coordinati con le maestranze." },
          { title: "Consegna al cliente", desc: "Appuntamento fisso, imballo rimosso, tutto al suo posto: la consegna che fa impressione." },
        ],
        form: {
          title: "Richiedi il servizio.",
          name: "Nome e cognome", company: "Azienda (facoltativo)", email: "Email", phone: "Telefono",
          type: "Di cosa hai bisogno?", typeOptions: ["Ritiro presso fornitore", "Trasporto", "Consegna in cantiere", "Consegna al cliente", "Altro"],
          place: "Luogo (partenza e destinazione)", date: "Data indicativa",
          notes: "Note (facoltative)", send: "Invia la richiesta",
          success: "Richiesta ricevuta: il team OMNIWAY ti ricontatta subito con la conferma.",
        },
      },
    },
    nav: {
      about: "Chi siamo",
      metodo: "Il metodo",
      portfolio: "Portfolio",
      showroom: "Showroom",
      contact: "Contatti",
      cta: "Richiedi una consulenza",
      tagline: "your home, our care.",
    },
    hero: {
      overline: "General Contractor · Progettazione · Showroom",
      lines: ["your home,", "our care."],
      ctaPrimary: "Scopri il portfolio",
      ctaSecondary: "Parliamone",
      location: "Roma — Italia",
    },
    about: {
      title: "Il lusso di *non pensarci*, affidati a noi.",
      p1: "Green Gate è un general contractor che riunisce sotto un'unica regia competenze, professionalità e servizi complementari. In collaborazione con architetti di riferimento, accompagniamo ogni progetto dalla prima idea alla realizzazione finale, integrando progettazione, preventivazione, gestione del cantiere, showroom, forniture e logistica interna.",
      p2: "Ogni area opera in sinergia con le altre, seguendo un processo coordinato e continuo. Dalla verifica della documentazione alla selezione dei materiali, dal coordinamento delle maestranze al ritiro e alla consegna diretta delle forniture, gestiamo ogni passaggio con attenzione e controllo.",
      closing: "Un'unica regia, competenze diverse, un percorso senza *interruzioni*.",
      chiTitle: "Le persone dietro i *progetti*.",
      chiP1: "Green Gate è un general contractor e studio di interior design con sede a Roma. Siamo un team che lavora allo stesso tavolo: chi progetta, chi tiene il cantiere e chi segue lo showroom si parla ogni giorno.",
      chiP2: "Attorno alla squadra, una rete di artigiani e maestri che collabora con noi progetto dopo progetto: ebanisti, marmisti, installatori. Persone che entrano in cantiere come di casa.",
      chiClosing: "Ruoli diversi, una sola squadra, la stessa cura per i *dettagli*.",
      stats: [
        { to: 25, suffix: "+", label: "Anni di esperienza" },
        { to: 300, suffix: "+", label: "Progetti consegnati" },
        { to: 60, suffix: "", label: "Artigiani e maestri partner" },
      ],
      caption: "Un percorso tra materiali, luce e proporzioni.",
      detailAlt: "Scalone in marmo con lampadario nello showroom Green Gate",
    },
    team: {
      overline: "Chi siamo",
      title: "Un team che si conosce da *anni*.",
      years: "25+ anni di esperienza",
    },
    showroom: {
      overline: "Showroom",
      title: "Il meglio del design, tutto in un *posto*.",
      city: "Roma",
      cta: "Entra nello showroom",
    },
    showroomPage: {
      intro: "Un percorso tra materiali, luce e proporzioni: lo showroom Green Gate è la casa dei migliori marchi dell'interior design. Dentro trovi la selezione dei prodotti su misura e tutti i partner con cui lavoriamo, categoria per categoria.",
      location: {
        eyebrow: "Dove siamo",
        title: "A due passi da *Trastevere*.",
        text: "Lo showroom Green Gate è uno spazio di arredamento e interior design nel cuore del centro storico di Roma: materiali, finiture e i migliori marchi del design, da vivere dal vivo.",
        mapsCta: "Indicazioni su Google Maps",
        mapsUrl: "https://www.google.com/maps/search/?api=1&query=Piazza+delle+Cinque+Scole+40-41+00186+Roma",
      },
    },
    statement: {
      eyebrow: "Riservatezza",
      line: "La *discrezione* è parte del progetto.",
      sub: "Molti dei nostri progetti restano riservati: ville e appartamenti di clienti che scelgono di proteggere la propria privacy. Raccontiamo solo ciò che i clienti ci permettono di mostrare. Ogni lavoro — pubblicato o riservato — è seguito dal nostro team, con gli architetti di riferimento dello studio, dal primo sopralluogo alla consegna.",
    },
    services: {
      overline: "Servizi",
      items: [
        {
          num: "01",
          icon: "compass",
          title: "Architettura e Design d'Interni",
          desc: "Progettazione in collaborazione con architetti di riferimento.",
        },
        {
          num: "02",
          icon: "hardhat",
          title: "Realizzazioni",
          desc: "Preventivazione, coordinamento delle imprese, gestione del cantiere e verifica documentale con professionisti competenti.",
        },
        {
          num: "03",
          icon: "sofa",
          title: "Showroom e Arredamento",
          desc: "Selezione, consulenza e fornitura di arredi, illuminazione, materiali e finiture.",
        },
        {
          num: "04",
          icon: "truck",
          title: "Logistica",
          desc: "Gestione logistica interna, ritiro diretto presso i fornitori, trasporto con mezzi propri e consegna in cantiere o al cliente.",
        },
      ],
      journey: {
        title: "Dall'*idea* alla *realizzazione*.",
        sub: "General Contractor: progettazione, showroom e realizzazione.\nTUTTO CON UN UNICO INTERLOCUTORE",
        image: "/progetti/in-studio-materiali.webp",
        imageCaption: "In studio — la selezione dei materiali.",
        steps: [
          { num: "01", title: "Ascoltare", sub: "Partiamo dal tuo spazio e dal tuo modo di viverlo.", desc: "Ci incontriamo in showroom o direttamente sul posto per capire esigenze, stile, priorità e budget. Analizziamo gli spazi e costruiamo il progetto." },
          { num: "02", title: "Progettare", sub: "Diamo forma alle idee, fino all'ultimo dettaglio.", desc: "Progettiamo ambienti, arredi e finiture selezionando materiali e soluzioni dal nostro showroom. Ti presentiamo un progetto completo e un quadro economico chiaro, prima di iniziare." },
          { num: "03", title: "Realizzare", sub: "Coordiniamo tutto. Tu devi solo vedere il risultato.", desc: "Come general contractor, gestiamo imprese, artigiani, fornitori e tempi di cantiere. Seguiamo la realizzazione dall'inizio alla fine, mantenendo una sola regia e un unico referente." },
        ],
      },
    },
    custom: {
      overline: "Su misura",
      title: "Prodotti *custom*, dal disegno alla materia.",
      sub: "Lo studio disegna e segue la realizzazione di pezzi unici, prodotti su misura dai nostri maestri artigiani: dal singolo mobile all'arredo completo.",
      items: [
        { icon: "armchair", title: "Mobili su misura", desc: "Comò, consolle, tavoli e librerie disegnati dallo studio e realizzati a mano." },
        { icon: "pot", title: "Cucine custom", desc: "Cucine progettate sull'esperienza di chi le vive: materiali, elettrodomestici e dettagli scelti insieme." },
        { icon: "package", title: "Armadi & cabine armadio", desc: "Sistemi giorno e notte con interni organizzati su ogni misura e abitudine." },
        { icon: "bath", title: "Bagno su misura", desc: "Lavabi, mobili e top disegnati e prodotti ad hoc, anche in esemplare unico." },
        { icon: "door", title: "Porte & boiserie", desc: "Fili continui che percorrono la casa: porte, pannellature e boiserie su disegno." },
        { icon: "lamp", title: "Luce & dettagli", desc: "Lampade e elementi decorativi disegnati dallo studio in serie limitata." },
      ],
      cta: "Richiedi un pezzo su misura",
    },
    works: {
      overline: "Portfolio",
      title: "Una selezione dei nostri *progetti*.",
      all: "Tutti",
    },
    home: {
      eyebrow: "Green Gate S.r.l.",
      teamCta: "Scopri il team",
      worksCta: "Vedi tutti i lavori",
    },
    portfolio: {
      overline: "Portfolio",
      title: "Progetti.",
      items: [
        {
          title: "Centro Polifunzionale", location: "", year: "", type: "Contract",
          slug: "centro-polifunzionale", surface: "",
          desc: "Un grande edificio pubblico e polivalente: un volume orizzontale sospeso sull'acqua che accoglie funzioni diverse sotto un'unica copertura. Green Gate lo ha seguito con il proprio metodo — ascolto, progetto, coordinamento — fino alla consegna.",
          img: "/progetti/centro-polifunzionale-5.webp",
          gallery: [
            "/progetti/centro-polifunzionale-1.webp",
            "/progetti/centro-polifunzionale-2.webp",
            "/progetti/centro-polifunzionale-3.webp",
            "/progetti/centro-polifunzionale-4.webp",
            "/progetti/centro-polifunzionale-6.webp",
            "/progetti/centro-polifunzionale-7.webp",
        ],
          services: [],
      },
        {
          title: "Villa Privata in Toscana", location: "Grosseto", year: "", type: "Residenziale",
          slug: "villa-privata-toscana", surface: "450 m²",
          desc: "Una villa privata nel cuore della Maremma, seguita chiavi in mano: dalla consulenza di design d'interni e architettura alle forniture di cantiere, fino agli arredamenti su misura. 450 m² di interni eleganti e luminosi, disegnati su misura per chi li abita.",
          img: "/progetti/villa-toscana-1.webp",
          gallery: [
            "/progetti/villa-toscana-2.webp",
            "/progetti/villa-toscana-3.webp",
            "/progetti/villa-toscana-4.webp",
            "/progetti/villa-toscana-5.webp",
            "/progetti/villa-toscana-8.webp",
            "/progetti/villa-toscana-9.webp",
        ],
          services: [
            "Chiavi in mano",
            "Design d'interni",
            "Consulenza di architettura",
            "Arredamenti su misura",
        ],
      },
        {
          title: "Villa Privata a Grottaferrata", location: "Grottaferrata", year: "", type: "Residenziale",
          slug: "villa-privata-grottaferrata", surface: "367 m²",
          desc: "Una villa privata ai Castelli Romani, seguita chiavi in mano: design d'interni, consulenza di architettura, forniture di cantiere e arredamenti su misura. Le pareti in onice retroilluminato e i parquet a spina di pesce disegnano uno spazio intimo e scenografico.",
          img: "/progetti/villa-grottaferrata-4.webp",
          gallery: [
            "/progetti/villa-grottaferrata-1.webp",
            "/progetti/villa-grottaferrata-2.webp",
            "/progetti/villa-grottaferrata-3.webp",
            "/progetti/villa-grottaferrata-5.webp",
            "/progetti/villa-grottaferrata-6.webp",
            "/progetti/villa-grottaferrata-7.webp",
            "/progetti/villa-grottaferrata-8.webp",
        ],
          services: [
            "Chiavi in mano",
            "Design d'interni",
            "Consulenza di architettura",
            "Arredamenti su misura",
        ],
      },
        {
          title: "Beauty Store", location: "Roma, Piazza Navona", year: "", type: "Contract",
          slug: "beauty-store", surface: "274 m²",
          desc: "Un beauty store nel cuore di Roma, a pochi passi da Piazza Navona: 274 m² di spazio vendita seguiti chiavi in mano — design d'interni, consulenza di architettura, forniture di cantiere e arredamenti su misura. Legni pregiati, tende d'oro e luci scenografiche disegnano un'esperienza d'acquisto teatrale.",
          img: "/progetti/beauty-store-3.webp",
          gallery: [
            "/progetti/beauty-store-1.webp",
            "/progetti/beauty-store-2.webp",
            "/progetti/beauty-store-4.webp",
            "/progetti/beauty-store-5.webp",
            "/progetti/beauty-store-6.webp",
            "/progetti/beauty-store-7.webp",
            "/progetti/beauty-store-8.webp",
            "/progetti/beauty-store-9.webp",
            "/progetti/beauty-store-10.webp",
            "/progetti/beauty-store-11.webp",
            "/progetti/beauty-store-12.webp",
            "/progetti/beauty-store-13.webp",
        ],
          services: [
            "Chiavi in mano",
            "Design d'interni",
            "Consulenza di architettura",
            "Arredamenti su misura",
        ],
      },
        {
          title: "Appartamento Privato a Prati", location: "Roma, Prati", year: "", type: "Residenziale",
          slug: "appartamento-privato-prati", surface: "340 m²",
          desc: "Un appartamento privato nel cuore di Prati, a Roma: 340 m² seguiti chiavi in mano — dalla consulenza di architettura alle forniture di cantiere, fino agli arredamenti su misura. Pareti in lamiera ossidata, vetro di Murano e luce che corre a pavimento disegnano uno spazio sofisticato e accogliente.",
          img: "/progetti/appartamento-prati-1.webp",
          gallery: [
            "/progetti/appartamento-prati-1.webp",
            "/progetti/appartamento-prati-3.webp",
            "/progetti/appartamento-prati-4.webp",
            "/progetti/appartamento-prati-5.webp",
            "/progetti/appartamento-prati-6.webp",
            "/progetti/appartamento-prati-7.webp",
            "/progetti/appartamento-prati-8.webp",
            "/progetti/appartamento-prati-9.webp",
            "/progetti/appartamento-prati-10.webp",
        ],
          services: [
            "Chiavi in mano",
            "Consulenza di architettura",
            "Forniture di cantiere",
            "Arredamenti su misura",
        ],
      },
        {
          title: "Attico Privato", location: "Roma, Centro Storico", year: "", type: "Residenziale",
          slug: "attico-privato-prati", surface: "50 m²",
          desc: "Un attico di 50 m² nel cuore del centro storico di Roma: travi a vista, terrazza sui tetti con le cupole e cucina disegnata su misura. Seguito chiavi in mano — dalla consulenza di architettura alle forniture di cantiere — uno spazio piccolo nelle dimensioni, grande nel carattere.",
          img: "/progetti/attico-prati-4.webp",
          gallery: [
            "/progetti/attico-prati-1.webp",
            "/progetti/attico-prati-5.webp",
            "/progetti/attico-prati-6.webp",
            "/progetti/attico-prati-7.webp",
            "/progetti/attico-prati-8.webp",
            "/progetti/attico-prati-9b.webp",
        ],
          services: [
            "Chiavi in mano",
            "Consulenza di architettura",
            "Forniture di cantiere",
            "Arredamenti su misura",
        ],
      },
        {
          title: "Appartamento Privato a Parigi", location: "Parigi, Place d'Iéna", year: "", type: "Residenziale",
          slug: "appartamento-privato-parigi", surface: "430 m²",
          desc: "Un appartamento privato su Place d'Iéna, a Parigi: 430 m² di interni seguiti chiavi in mano — dalla consulenza di architettura alle forniture di cantiere, fino agli arredamenti su misura. La scala sospesa, i marmi e le opere d'arte disegnano uno spazio che vive di arte e luce.",
          img: "/progetti/appartamento-parigi-4.webp",
          gallery: [
            "/progetti/appartamento-parigi-1.webp",
            "/progetti/appartamento-parigi-2.webp",
            "/progetti/appartamento-parigi-3.webp",
            "/progetti/appartamento-parigi-5.webp",
            "/progetti/appartamento-parigi-6.webp",
            "/progetti/appartamento-parigi-7.webp",
            "/progetti/appartamento-parigi-9.webp",
        ],
          services: [
            "Chiavi in mano",
            "Consulenza di architettura",
            "Forniture di cantiere",
            "Arredamenti su misura",
        ],
      },
        {
          title: "Taverna Trilussa — Sala Roger Federer", location: "Roma, Trastevere", year: "", type: "Contract",
          slug: "taverna-trilussa", surface: "100 m²",
          desc: "La Sala Roger Federer della Taverna Trilussa, a Roma: 100 m² tra storia e contemporaneo — travi a vista, vetrine illuminate per cantina e dispensa, un bancone scultoreo in travertino con piano in vetro nero e un portalone nero che introduce alla sala. Seguiti chiavi in mano: design d'interni, forniture e arredamenti su misura.",
          img: "/progetti/taverna-trilussa-1.webp",
          gallery: [
            "/progetti/taverna-trilussa-2.webp",
            "/progetti/taverna-trilussa-3.webp",
            "/progetti/taverna-trilussa-4.webp",
            "/progetti/taverna-trilussa-5.webp",
            "/progetti/taverna-trilussa-6.webp",
            "/progetti/taverna-trilussa-7.webp",
            "/progetti/taverna-trilussa-8.webp",
        ],
          services: [
            "Chiavi in mano",
            "Design d'interni",
            "Forniture di cantiere",
            "Arredamenti su misura",
        ],
      },
      ],
    },
    partners: {
      overline: "Partner",
      title: "Aziende con cui collaboriamo.",
      visitSite: "Visita il sito",
      back: "Tutte le categorie",
      empty: "Le aziende di questa categoria arriveranno a breve.",
      companies: "aziende",
      taxonomy: [
        { key: "pavimenti", label: "Pavimenti e rivestimenti", groups: [
          { key: "parquet", label: "Parquet" },
          { key: "pietre", label: "Pietre" },
          { key: "gress", label: "Gress" },
        ] },
        { key: "bagno", label: "Bagno" },
        { key: "cucina", label: "Cucina" },
        { key: "elettrodomestici", label: "Elettrodomestici" },
        { key: "arredamento", label: "Arredamento" },
        { key: "outdoor", label: "Arredamento outdoor" },
        { key: "illuminazione", label: "Illuminazione" },
        { key: "impianti", label: "Impianti tecnologici" },
      ],
      categories: [
        {
          name: "Pavimenti e rivestimenti",
          groups: [
            { name: "Parquet", brands: ["Legno Vivo", "Parchettificio Romano"] },
            { name: "Pietre", brands: ["Marmi Vagli 1872", "Lithos Romana"] },
            { name: "Gress", brands: ["Fonte Ceramica", "Ceramica Aurea"] },
          ],
        },
        { name: "Bagno", brands: ["Aqua Domus", "Rubinetterie d'Epoca"] },
        { name: "Cucina", brands: ["Cucine d'Arte", "Fucina Cucine"] },
        { name: "Elettrodomestici", brands: ["Gourmet Elettrodomestici", "Linea Fuoco"] },
        { name: "Arredamento", brands: ["Ottobrass Milano", "Atelier Salotti"] },
        { name: "Arredamento outdoor", brands: ["Giardino Blu", "Teak Outdoor Roma"] },
        { name: "Illuminazione", brands: ["Luce Atelier", "Lumi Veneziani"] },
        { name: "Impianti tecnologici", brands: ["TecnoImpianti Roma", "Idee Impianti"] },
      ],
    },
    architects: {
      items: [
        { name: "Dallara Francesca", role: "Designer", studio: "", img: "/images/arch/dallara.webp" },
        { name: "Domenico Saviano", role: "Architetto", studio: "", img: "/images/arch/saviano.jpg" },
        { name: "Logrippo Hawi", role: "Junior Designer", studio: "", img: "/images/arch/logrippo.webp" },
      ],
      quote: {
        text: "La materia parla, il progetto traduce.",
        author: "Green Gate — Design Team",
      },
    },
    project: {
      back: "Tutti i progetti",
      location: "Luogo",
      year: "Anno",
      type: "Tipologia",
      surface: "Superficie",
      client: "Cliente",
      work: "Lavoro",
      services: "Servizi",
      gallery: "Galleria",
      next: "Progetto successivo",
    },
    booking: {
      title: "Prenota la tua visita",
      pickDay: "Scegli il giorno",
      pickTime: "Scegli l'orario",
      details: "I tuoi dati",
      saturday: "Su appuntamento",
      closedSunday: "Chiuso domenica · Lun–Ven 10:00–18:30 · Sab su appuntamento",
      taken: "Occupato",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono (opzionale)",
      confirm: "Conferma la prenotazione",
      confirming: "Confermo…",
      success: "Visita prenotata!",
      successSub: "Ti aspettiamo allo showroom.",
      mailConfirm: "Invia conferma via email",
      waConfirm: "Invia su WhatsApp",
      confirmSubject: "La tua visita allo showroom Green Gate è confermata",
      confirmBody: "Gentile {name}, la sua visita allo showroom Green Gate è confermata: {date} alle {time} — Piazza delle Cinque Scole 40-41, Roma. Ti aspettiamo! — Green Gate S.r.l.",
      back: "Indietro",
      close: "Chiudi",
      loadFail: "Impossibile caricare la disponibilità",
      conflict: "Questo orario è appena stato prenotato. Scegline un altro.",
    },
    teaser: {
      title: "Un invito per te",
      text: "Vieni a scoprire lo showroom Green Gate nel cuore di Roma.",
      open: "Apri l'invito",
      dismiss: "Non più",
    },
    invite: {
      overline: "Green Gate S.r.l. — Showroom & General Contracting",
      inviteFor: "Un invito per",
      invitation: "Vieni a scoprire lo showroom Green Gate nel cuore di Roma: un percorso tra materiali, luce e proporzioni, e una consulenza pensata su di te.",
      whereLabel: "Dove",
      whenLabel: "Quando",
      cta: "Prenota la tua visita",
      shareTitle: "Invia l'invito a un cliente",
      nameLabel: "Nome dell'ospite (opzionale)",
      whatsapp: "WhatsApp",
      email: "Email",
      copy: "Copia il link",
      copied: "Link copiato!",
      shareText: "Ti invito a scoprire lo showroom Green Gate a Roma — Piazza delle Cinque Scole 40-41.",
    },
    collab: {
      overline: "Collaborazioni",
      title: "Lavoriamo *insieme*.",
      sub: "Sei un'azienda del settore o uno studio di architettura? Presentaci la tua realtà: cerchiamo partner che condividano la nostra idea di qualità.",
      cards: [
        { icon: "building", title: "Per le aziende", text: "Fornitori, artigiani e brand che vogliono entrare nel nostro mondo e nei nostri progetti." },
        { icon: "compass", title: "Per architetti e studi", text: "Studi e professionisti con cui progettare e realizzare opere su misura." },
      ],
      form: {
        type: "Sono",
        types: ["Un'azienda", "Un architetto / uno studio"],
        name: "Nome e cognome",
        company: "Azienda / Studio",
        email: "Email",
        category: "Settore",
        categories: ["Pavimenti e rivestimenti", "Bagno", "Cucina", "Elettrodomestici", "Arredamento", "Arredamento outdoor", "Illuminazione", "Impianti tecnologici", "Altro"],
        message: "Presentaci la tua attività",
        submit: "Invia la candidatura",
        sending: "Invio in corso…",
        success: "Candidatura ricevuta, grazie.",
        successSub: "Ti ricontatteremo al più presto per conoscerci.",
        error: "Si è verificato un errore. Riprova o scrivici a info@greengatesrl.it",
      },
    },
    contact: {
      overline: "Contatti",
      title: "Parliamo del *tuo spazio*.",
      sub: "Raccontaci il progetto che hai in mente: ti risponderemo entro 24 ore lavorative per fissare un primo incontro, in showroom o in cantiere.",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono (opzionale)",
        message: "Raccontaci il tuo progetto",
        submit: "Invia la richiesta",
        sending: "Invio in corso…",
        success: "Richiesta inviata con successo.",
        successSub: "Ti risponderemo entro 24 ore lavorative.",
        error: "Si è verificato un errore. Riprova o scrivici a info@greengatesrl.it",
      },
      info: {
        showroomLabel: "Showroom",
        showroom: "Piazza delle Cinque Scole 40-41\n00186 Roma (RM)",
        phoneLabel: "Telefono",
        phone: "+39 06 69326685",
        emailLabel: "Email",
        email: "info@greengatesrl.it",
        hoursLabel: "Orari",
        hours: "Lun – Ven 10:00 – 18:30\nSab su appuntamento",
      },
    },
    cookies: {
      title: "Privacy & Cookie",
      text: "Questo sito utilizza cookie tecnici e, con il tuo consenso, cookie di misurazione per migliorare l'esperienza di navigazione. Le tue richieste dal form vengono trattate secondo la normativa privacy.",
      accept: "Accetta",
      reject: "Rifiuta",
    },
    footer: {
      tagline: "General contractor di design d'interni e showroom. Progettiamo, costruiamo e arrediamo spazi che durano nel tempo.",
      slogan: "Green Gate — your home, our care.",
      navTitle: "Esplora",
      contactTitle: "Contatti",
      rights: "© Green Gate S.r.l. Tutti i diritti riservati.",
      piva: "P.IVA 17810791008 · C.F. 17810791008 · REA RM 1742929 · Cod. univoco W4KYJ8V · PEC greengate@legalmail.it",
      top: "Torna su",
      admin: "Area partner",
      disclaimer: "I contenuti di questo sito sono di proprietà di Green Gate S.r.l. e non possono essere riprodotti senza autorizzazione. Le immagini sono a scopo illustrativo.",
    },
  },

  en: {
    servicePages: {
      interior: {
        overline: "Architecture & Interior Design",
        title: "Vision precedes the site.",
        intro: "We work in collaboration with our reference architects, from the site survey to the study of spaces, down to every technical and decorative detail. Fill in the guided form: it helps us understand your space and prepare a real quote.",
        phases: [
          { num: "01", items: ["Surveys, measurements and analysis", "Technical and economic feasibility study", "Design", "Moodboard", "Renders", "Landscape"] },
          { num: "02", items: ["Building permits", "Public land occupation", "Fire prevention"] },
          { num: "03", items: ["Executive drawings: electrical, mechanical and more", "Safety coordination (CSP-CSE)", "Construction supervision"] },
          { num: "04", items: ["Property registry filing", "Certificate of habitability"] },
        ],
        form: {
          title: "Guided quote.",
          name: "Full name",
          phoneOptional: "Phone (optional)",
          desc: "Tell us about the space: we will get back to you with a detailed quote.",
          step1: { label: "What kind of space is it?", options: ["Apartment", "Detached house", "Office", "Shop / showroom", "Other"] },
          step2: { area: "Surface in m² (approx.)", rooms: "Main rooms (e.g. 2 bedrooms, living room, 1 bathroom)" },
          step3: { finish: "Finish level", finishOptions: ["Essential", "Medium", "High"], condition: "Current state of the space", conditionOptions: ["Empty", "Furnished / lived in", "To be renovated"] },
          step4: { services: "What do you need?", servicesOptions: ["Design only", "Design + supplies", "Turnkey"], notes: "Notes (optional)", notesPlaceholder: "Timeline, constraints, particularities…" },
          back: "Back", next: "Next", send: "Send the request",
          success: "Request received. We will get back to you with the quote within one working day.",
        },
      },
      contracting: {
        overline: "Realizations",
        works: ["Site set-up", "Demolition and construction", "Load-bearing wall works", "Mechanical systems", "Electrical systems", "Special systems", "Windows and doors", "External works", "Cladding and decorations", "Landscaping"],
        title: "One direction, a site with no worries.",
        intro: "We coordinate every contractor, craftsman and supplier with a single direction and verified timelines. And we handle the paperwork that unlocks your site — also as a standalone service, if that is all you are looking for.",
        docs: {
          title: "The documents that unlock your site.",
          desc: "Every project has a different bureaucratic path: we take it from start to finish.",
          items: [
            { name: "CILA", desc: "The sworn notice of start of works: the green light for minor works, signed by a qualified professional. Required for many renovations without a change of use." },
            { name: "SCIA", desc: "The permit for more significant works: change of use, demolitions, structural work. We file it and follow the timelines with the Municipality." },
            { name: "Asl notice", desc: "The site notification to the local health authority: mandatory before opening the site. We prepare it with the contractors' details." },
            { name: "Habitability", desc: "At the end of the works, the habitability certificate (or conforming communications) makes the property compliant. We obtain it, including signed system annexes." },
            { name: "Municipal permits", desc: "Public ground occupation, landscape authorisation, nearby business clearance: we check which one is needed and apply for it." },
            { name: "Systems compliance", desc: "The compliance declaration of every system (electrical, plumbing, gas): we collect it from the professionals and hand it to the client." },
          ],
          cta: "I only need this support",
          form: {
            title: "Document support.",
            desc: "Tell us about the practice: we will immediately tell you if and how we can take it over.",
            name: "Full name", email: "Email", phone: "Phone (optional)", message: "The practice or document you need",
            send: "Send the request", success: "Request received: we will get back to you within one working day.",
          },
        },
      },
      showroom: {
        overline: "Showroom & Furnishing",
        title: "The best of design, all in one place.",
        intro: "In our showroom we select furniture, lighting, materials and finishes with personal advisory: you try materials in person, touch the fabrics and compose your home or workspace together.",
        highlights: [
          { title: "Materials in person", desc: "Marbles, woods, porcelain and finishes to try with your hands, not from a catalogue." },
          { title: "Personal advisory", desc: "We guide the choice, coordinating every room with the project." },
          { title: "Selected brands", desc: "The best companies for every area of the home, with delivery taken care of." },
        ],
        cta: "Discover our partner companies",
        ctaCustom: "Request a bespoke piece",
      },
      omniway: {
        overline: "Logistics",
        brand: "OMNIWAY",
        by: "by Green Gate S.r.l.",
        title: "Logistics is the last thing you think about. And the first thing we think about.",
        intro: "OMNIWAY is Green Gate's in-house logistics service: we collect directly from suppliers, transport with our own fleet and deliver on site or to the client, exactly on time.",
        services: [
          { title: "Supplier collection", desc: "We pick up materials directly from factories, showrooms and warehouses." },
          { title: "Own-fleet transport", desc: "Our vehicle fleet, in every size: from a single piece of furniture to a whole site." },
          { title: "Site delivery", desc: "Unloading, staging and placement on the right floor, coordinated with the crews." },
          { title: "Client delivery", desc: "Fixed appointment, packaging removed, everything in place: the delivery that impresses." },
        ],
        form: {
          title: "Request the service.",
          name: "Full name", company: "Company (optional)", email: "Email", phone: "Phone",
          type: "What do you need?", typeOptions: ["Collection from supplier", "Transport", "Site delivery", "Client delivery", "Other"],
          place: "Location (pickup and destination)", date: "Indicative date",
          notes: "Notes (optional)", send: "Send the request",
          success: "Request received: the OMNIWAY team will contact you right away with confirmation.",
        },
      },
    },
    nav: {
      about: "About us",
      metodo: "The process",
      portfolio: "Portfolio",
      showroom: "Showroom",
      contact: "Contact",
      cta: "Request a consultation",
      tagline: "your home, our care.",
    },
    hero: {
      overline: "General Contractor · Design · Showroom",
      lines: ["your home,", "our care."],
      ctaPrimary: "View portfolio",
      ctaSecondary: "Let's talk",
      location: "Rome — Italy",
    },
    about: {
      title: "The luxury of *letting go*, trust us.",
      p1: "Green Gate is a general contractor that brings competencies, professionalism and complementary services under one direction. In collaboration with our reference architects, we take every project from the first idea to final delivery, integrating design, budgeting, site management, showroom, supplies and in-house logistics.",
      p2: "Every area works in synergy with the others, following a coordinated, continuous process. From document checks to material selection, from coordinating crews to collecting and delivering supplies directly, we handle every step with attention and control.",
      closing: "One direction, different skills, a journey without *interruptions*.",
      chiTitle: "The people behind the *projects*.",
      chiP1: "Green Gate is a general contractor and interior design studio based in Rome. We are a team working at the same table: those who design, those who run the site and those who manage the showroom talk every day.",
      chiP2: "Around the team, a network of artisans and masters who work with us project after project: cabinetmakers, stonemasons, installers. People who step onto site like it's their own home.",
      chiClosing: "Different roles, one team, the same care for *details*.",
      stats: [
        { to: 25, suffix: "+", label: "Years of experience" },
        { to: 300, suffix: "+", label: "Projects delivered" },
        { to: 60, suffix: "", label: "Partner craftsmen & makers" },
      ],
      caption: "A journey through materials, light and proportion.",
      detailAlt: "Marble staircase with chandelier in the Green Gate showroom",
    },
    team: {
      overline: "About us",
      title: "A team that has known each other for *years*.",
      years: "25+ years of experience",
    },
    showroom: {
      overline: "Showroom",
      title: "The best of design, all in one *place*.",
      city: "Rome",
      cta: "Enter the showroom",
    },
    showroomPage: {
      intro: "A journey through materials, light and proportion: the Green Gate showroom is the home of the best interior design brands. Inside you'll find the custom-made selection and all the partners we work with, category by category.",
    },
    statement: {
      eyebrow: "Discretion",
      line: "Discretion is *part of the project*.",
      sub: "Many of our projects remain confidential: villas and apartments belonging to clients who protect their privacy. We tell only what our clients allow us to show. Every project — published or confidential — is followed by our team, with the studio's reference architects, from the first survey to handover.",
    },
    services: {
      overline: "Services",
      items: [
        {
          num: "01",
          icon: "compass",
          title: "Architecture & Interior Design",
          desc: "Design in collaboration with our reference architects.",
        },
        {
          num: "02",
          icon: "hardhat",
          title: "Realizations",
          desc: "Budgeting, coordination of contractors, site management and document checks with qualified professionals.",
        },
        {
          num: "03",
          icon: "sofa",
          title: "Showroom & Furnishing",
          desc: "Selection, consulting and supply of furniture, lighting, materials and finishes.",
        },
        {
          num: "04",
          icon: "truck",
          title: "Logistics",
          desc: "In-house logistics, direct collection from suppliers, transport with our own fleet and delivery on site or to the client.",
        },
      ],
      journey: {
        title: "From *idea* to *completion*.",
        sub: "General Contractor: design, showroom and construction.\nALL WITH ONE SINGLE POINT OF CONTACT",
        image: "/progetti/in-studio-materiali.webp",
        imageCaption: "In the studio — material selection.",
        steps: [
          { num: "01", title: "Listen", sub: "We start from your space and the way you live it.", desc: "We meet at the showroom or on site to understand needs, style, priorities and budget. We analyse the spaces and shape the project together." },
          { num: "02", title: "Design", sub: "We give shape to ideas, down to the last detail.", desc: "We design rooms, furniture and finishes, selecting materials and solutions from our showroom. You get a complete project and a clear budget before works begin." },
          { num: "03", title: "Deliver", sub: "We coordinate everything. You just enjoy the result.", desc: "As general contractor, we manage contractors, craftsmen, suppliers and site timelines — one direction, one referent, from start to finish." },
        ],
      },
    },
    custom: {
      overline: "Bespoke",
      title: "*Custom* products, from drawing to matter.",
      sub: "The studio designs and follows the making of one-of-a-kind pieces, produced to measure by our master craftsmen: from a single piece of furniture to a complete interior.",
      items: [
        { icon: "armchair", title: "Custom furniture", desc: "Dressers, consoles, tables and bookcases designed by the studio and made by hand." },
        { icon: "pot", title: "Custom kitchens", desc: "Kitchens designed around the experience of those who live them: materials, appliances and details chosen together." },
        { icon: "package", title: "Wardrobes & walk-in closets", desc: "Day and night systems with interiors organised around every measure and habit." },
        { icon: "bath", title: "Custom bathrooms", desc: "Basins, units and tops designed and produced ad hoc, even as one-off pieces." },
        { icon: "door", title: "Doors & wall panelling", desc: "Continuous lines running through the home: doors, panelling and boiserie to design." },
        { icon: "lamp", title: "Light & details", desc: "Lamps and decorative elements designed by the studio in limited series." },
      ],
      cta: "Request a bespoke piece",
    },
    works: {
      overline: "Portfolio",
      title: "A selection of our *projects*.",
      all: "All",
    },
    home: {
      eyebrow: "Green Gate S.r.l.",
      teamCta: "Meet the team",
      worksCta: "View all works",
    },
    portfolio: {
      overline: "Portfolio",
      title: "Projects.",
      items: [
        {
          title: "Centro Polifunzionale", location: "", year: "", type: "Contract",
          slug: "centro-polifunzionale", surface: "",
          desc: "A large public, multi-purpose building: a horizontal volume suspended over water, hosting different functions under a single roof. Green Gate followed it with its own method — listening, design, coordination — through to handover.",
          img: "/progetti/centro-polifunzionale-5.webp",
          gallery: [
            "/progetti/centro-polifunzionale-1.webp",
            "/progetti/centro-polifunzionale-2.webp",
            "/progetti/centro-polifunzionale-3.webp",
            "/progetti/centro-polifunzionale-4.webp",
            "/progetti/centro-polifunzionale-6.webp",
            "/progetti/centro-polifunzionale-7.webp",
        ],
          services: [],
      },
        {
          title: "Private Villa in Tuscany", location: "Grosseto", year: "", type: "Residential",
          slug: "villa-privata-toscana", surface: "450 m²",
          desc: "A private villa in the heart of Maremma, followed turnkey: from interior design and architecture consultancy to works supplies and custom furniture. 450 sq.m of elegant, luminous interiors, tailored to those who live in them.",
          img: "/progetti/villa-toscana-1.webp",
          gallery: [
            "/progetti/villa-toscana-2.webp",
            "/progetti/villa-toscana-3.webp",
            "/progetti/villa-toscana-4.webp",
            "/progetti/villa-toscana-5.webp",
            "/progetti/villa-toscana-8.webp",
            "/progetti/villa-toscana-9.webp",
        ],
          services: [
            "Turnkey Solution",
            "Interior Design",
            "Architecture Consultancy",
            "Custom Furniture",
        ],
      },
        {
          title: "Private Villa in Grottaferrata", location: "Grottaferrata", year: "", type: "Residential",
          slug: "villa-privata-grottaferrata", surface: "367 m²",
          desc: "A private villa in the Castelli Romani, followed turnkey: interior design, architecture consultancy, works supplies and custom furniture. Backlit onyx walls and herringbone parquet define an intimate, theatrical space.",
          img: "/progetti/villa-grottaferrata-4.webp",
          gallery: [
            "/progetti/villa-grottaferrata-1.webp",
            "/progetti/villa-grottaferrata-2.webp",
            "/progetti/villa-grottaferrata-3.webp",
            "/progetti/villa-grottaferrata-5.webp",
            "/progetti/villa-grottaferrata-6.webp",
            "/progetti/villa-grottaferrata-7.webp",
            "/progetti/villa-grottaferrata-8.webp",
        ],
          services: [
            "Turnkey Solution",
            "Interior Design",
            "Architecture Consultancy",
            "Custom Furniture",
        ],
      },
        {
          title: "Beauty Store", location: "Rome, Piazza Navona", year: "", type: "Contract",
          slug: "beauty-store", surface: "274 m²",
          desc: "A beauty store in the heart of Rome, a stone's throw from Piazza Navona: 274 sq.m of retail space followed turnkey — interior design, architecture consultancy, works supplies and custom furniture. Fine woods, golden curtains and layered lighting shape a dramatic, immersive shopping experience.",
          img: "/progetti/beauty-store-3.webp",
          gallery: [
            "/progetti/beauty-store-1.webp",
            "/progetti/beauty-store-2.webp",
            "/progetti/beauty-store-4.webp",
            "/progetti/beauty-store-5.webp",
            "/progetti/beauty-store-6.webp",
            "/progetti/beauty-store-7.webp",
            "/progetti/beauty-store-8.webp",
            "/progetti/beauty-store-9.webp",
            "/progetti/beauty-store-10.webp",
            "/progetti/beauty-store-11.webp",
            "/progetti/beauty-store-12.webp",
            "/progetti/beauty-store-13.webp",
        ],
          services: [
            "Turnkey Solution",
            "Interior Design",
            "Architecture Consultancy",
            "Custom Furniture",
        ],
      },
        {
          title: "Private Apartment in Prati", location: "Rome, Prati", year: "", type: "Residential",
          slug: "appartamento-privato-prati", surface: "340 m²",
          desc: "A private apartment in the heart of Prati, Rome: 340 sq.m followed turnkey — from architecture consultancy to works supplies and custom furniture. Oxidised steel walls, Murano glass and floor-running light shape a sophisticated, welcoming space.",
          img: "/progetti/appartamento-prati-1.webp",
          gallery: [
            "/progetti/appartamento-prati-1.webp",
            "/progetti/appartamento-prati-3.webp",
            "/progetti/appartamento-prati-4.webp",
            "/progetti/appartamento-prati-5.webp",
            "/progetti/appartamento-prati-6.webp",
            "/progetti/appartamento-prati-7.webp",
            "/progetti/appartamento-prati-8.webp",
            "/progetti/appartamento-prati-9.webp",
            "/progetti/appartamento-prati-10.webp",
        ],
          services: [
            "Turnkey Solution",
            "Architecture Consultancy",
            "Works Supplies",
            "Custom Furniture",
        ],
      },
        {
          title: "Private Penthouse", location: "Rome, Historic Centre", year: "", type: "Residential",
          slug: "attico-privato-prati", surface: "50 m²",
          desc: "A 50 sq.m penthouse in the heart of Rome's historic centre: exposed beams, a rooftop terrace facing the domes and a bespoke kitchen. Followed turnkey — from architecture consultancy to works supplies — a small space with a big character.",
          img: "/progetti/attico-prati-4.webp",
          gallery: [
            "/progetti/attico-prati-1.webp",
            "/progetti/attico-prati-5.webp",
            "/progetti/attico-prati-6.webp",
            "/progetti/attico-prati-7.webp",
            "/progetti/attico-prati-8.webp",
            "/progetti/attico-prati-9b.webp",
        ],
          services: [
            "Turnkey Solution",
            "Architecture Consultancy",
            "Works Supplies",
            "Custom Furniture",
        ],
      },
        {
          title: "Private Apartment in Paris", location: "Paris, Place d'Iéna", year: "", type: "Residential",
          slug: "appartamento-privato-parigi", surface: "430 m²",
          desc: "A private apartment on Place d'Iéna, Paris: 430 sq.m of interiors followed turnkey — from architecture consultancy to works supplies and custom furniture. The floating staircase, marbles and artworks shape a space that lives on art and light.",
          img: "/progetti/appartamento-parigi-4.webp",
          gallery: [
            "/progetti/appartamento-parigi-1.webp",
            "/progetti/appartamento-parigi-2.webp",
            "/progetti/appartamento-parigi-3.webp",
            "/progetti/appartamento-parigi-5.webp",
            "/progetti/appartamento-parigi-6.webp",
            "/progetti/appartamento-parigi-7.webp",
            "/progetti/appartamento-parigi-9.webp",
        ],
          services: [
            "Turnkey Solution",
            "Architecture Consultancy",
            "Works Supplies",
            "Custom Furniture",
        ],
      },
        {
          title: "Taverna Trilussa — Roger Federer Room", location: "Rome, Trastevere", year: "", type: "Contract",
          slug: "taverna-trilussa", surface: "100 m²",
          desc: "The Roger Federer Room at Taverna Trilussa in Rome: 100 sq.m between history and contemporary — exposed beams, lit display cabinets for the wine cellar and pantry, a sculptural travertine counter with a black glass top and a black portal opening into the dining room. Turnkey: interior design, works supplies and custom furniture.",
          img: "/progetti/taverna-trilussa-1.webp",
          gallery: [
            "/progetti/taverna-trilussa-2.webp",
            "/progetti/taverna-trilussa-3.webp",
            "/progetti/taverna-trilussa-4.webp",
            "/progetti/taverna-trilussa-5.webp",
            "/progetti/taverna-trilussa-6.webp",
            "/progetti/taverna-trilussa-7.webp",
            "/progetti/taverna-trilussa-8.webp",
        ],
          services: [
            "Turnkey Solution",
            "Interior Design",
            "Works Supplies",
            "Custom Furniture",
        ],
      },
      ],
    },
    partners: {
      overline: "Partners",
      title: "Companies we work with.",
      visitSite: "Visit website",
      back: "All categories",
      empty: "Companies in this category are coming soon.",
      companies: "companies",
      taxonomy: [
        { key: "pavimenti", label: "Flooring & coverings", groups: [
          { key: "parquet", label: "Parquet" },
          { key: "pietre", label: "Stone" },
          { key: "gress", label: "Porcelain stoneware" },
        ] },
        { key: "bagno", label: "Bathroom" },
        { key: "cucina", label: "Kitchen" },
        { key: "elettrodomestici", label: "Appliances" },
        { key: "arredamento", label: "Furniture" },
        { key: "outdoor", label: "Outdoor furniture" },
        { key: "illuminazione", label: "Lighting" },
        { key: "impianti", label: "Technological systems" },
      ],
      categories: [
        {
          name: "Flooring & coverings",
          groups: [
            { name: "Parquet", brands: ["Legno Vivo", "Parchettificio Romano"] },
            { name: "Stone", brands: ["Marmi Vagli 1872", "Lithos Romana"] },
            { name: "Porcelain stoneware", brands: ["Fonte Ceramica", "Ceramica Aurea"] },
          ],
        },
        { name: "Bathroom", brands: ["Aqua Domus", "Rubinetterie d'Epoca"] },
        { name: "Kitchen", brands: ["Cucine d'Arte", "Fucina Cucine"] },
        { name: "Appliances", brands: ["Gourmet Elettrodomestici", "Linea Fuoco"] },
        { name: "Furniture", brands: ["Ottobrass Milano", "Atelier Salotti"] },
        { name: "Outdoor furniture", brands: ["Giardino Blu", "Teak Outdoor Roma"] },
        { name: "Lighting", brands: ["Luce Atelier", "Lumi Veneziani"] },
        { name: "Technological systems", brands: ["TecnoImpianti Roma", "Idee Impianti"] },
      ],
    },
    architects: {
      items: [
        { name: "Dallara Francesca", role: "Designer", studio: "", img: "/images/arch/dallara.webp" },
        { name: "Domenico Saviano", role: "Architect", studio: "", img: "/images/arch/saviano.jpg" },
        { name: "Logrippo Hawi", role: "Junior Designer", studio: "", img: "/images/arch/logrippo.webp" },
      ],
      quote: {
        text: "Matter speaks; design translates.",
        author: "Green Gate — Design Team",
      },
    },
    project: {
      back: "All projects",
      location: "Location",
      year: "Year",
      type: "Type",
      surface: "Area",
      client: "Client",
      work: "Scope",
      services: "Services",
      gallery: "Gallery",
      next: "Next project",
    },
    booking: {
      title: "Book your visit",
      pickDay: "Choose the day",
      pickTime: "Choose the time",
      details: "Your details",
      saturday: "By appointment",
      closedSunday: "Closed on Sunday · Mon–Fri 10:00–18:30 · Sat by appointment",
      taken: "Taken",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      confirm: "Confirm booking",
      confirming: "Booking…",
      success: "Visit booked!",
      successSub: "We'll be waiting for you at the showroom.",
      mailConfirm: "Send confirmation by email",
      waConfirm: "Send on WhatsApp",
      confirmSubject: "Your visit to the Green Gate showroom is confirmed",
      confirmBody: "Dear {name}, your visit to the Green Gate showroom is confirmed: {date} at {time} — Piazza delle Cinque Scole 40-41, Rome. We look forward to seeing you! — Green Gate S.r.l.",
      back: "Back",
      close: "Close",
      loadFail: "Could not load availability",
      conflict: "This slot was just booked. Please pick another.",
    },
    teaser: {
      title: "An invitation for you",
      text: "Come discover the Green Gate showroom in the heart of Rome.",
      open: "Open invitation",
      dismiss: "Don't show again",
    },
    invite: {
      overline: "Green Gate S.r.l. — Showroom & General Contracting",
      inviteFor: "An invitation for",
      invitation: "Come discover the Green Gate showroom in the heart of Rome: a journey through materials, light and proportion, and a consultation designed around you.",
      whereLabel: "Where",
      whenLabel: "When",
      cta: "Book your visit",
      shareTitle: "Send the invitation to a client",
      nameLabel: "Guest name (optional)",
      whatsapp: "WhatsApp",
      email: "Email",
      copy: "Copy link",
      copied: "Link copied!",
      shareText: "I invite you to discover the Green Gate showroom in Rome — Piazza delle Cinque Scole 40-41.",
    },
    collab: {
      overline: "Partnerships",
      title: "Let's work *together*.",
      sub: "Are you a company in the industry or an architecture studio? Introduce yourself: we are looking for partners who share our idea of quality.",
      cards: [
        { icon: "building", title: "For companies", text: "Suppliers, artisans and brands who want to join our world and our projects." },
        { icon: "compass", title: "For architects & studios", text: "Studios and professionals to design and build bespoke works with." },
      ],
      form: {
        type: "I am",
        types: ["A company", "An architect / a studio"],
        name: "Full name",
        company: "Company / Studio",
        email: "Email",
        category: "Sector",
        categories: ["Flooring & coverings", "Bathroom", "Kitchen", "Appliances", "Furniture", "Outdoor furniture", "Lighting", "Technological systems", "Other"],
        message: "Introduce your business",
        submit: "Send application",
        sending: "Sending…",
        success: "Application received, thank you.",
        successSub: "We will get back to you soon to meet you.",
        error: "Something went wrong. Please try again or write to info@greengatesrl.it",
      },
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about *your space*.",
      sub: "Tell us about the project you have in mind: we will reply within 24 working hours to arrange a first meeting, at the showroom or on site.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        message: "Tell us about your project",
        submit: "Send request",
        sending: "Sending…",
        success: "Request sent successfully.",
        successSub: "We will reply within 24 working hours.",
        error: "Something went wrong. Please try again or write to info@greengatesrl.it",
      },
      info: {
        showroomLabel: "Showroom",
        showroom: "Piazza delle Cinque Scole 40-41\n00186 Rome (RM)",
        phoneLabel: "Phone",
        phone: "+39 06 69326685",
        emailLabel: "Email",
        email: "info@greengatesrl.it",
        hoursLabel: "Opening hours",
        hours: "Mon – Fri 10:00 – 18:30\nSat by appointment",
      },
    },
    cookies: {
      title: "Privacy & Cookies",
      text: "This site uses technical cookies and, with your consent, measurement cookies to improve your browsing experience. Your form requests are processed in accordance with privacy law.",
      accept: "Accept",
      reject: "Reject",
    },
    footer: {
      tagline: "Interior design general contractor and showroom. We design, build and furnish spaces built to last.",
      slogan: "Green Gate — your home, our care.",
      navTitle: "Explore",
      contactTitle: "Contact",
      rights: "© Green Gate S.r.l. All rights reserved.",
      piva: "P.IVA 17810791008 · C.F. 17810791008 · REA RM 1742929 · Cod. univoco W4KYJ8V · PEC greengate@legalmail.it",
      top: "Back to top",
      admin: "Partner area",
      disclaimer: "The content of this website is the property of Green Gate S.r.l. and may not be reproduced without authorisation. Images are for illustration purposes.",
    },
  },
};
